import { useEffect, useMemo, useState } from "react";
import { fetchSchools } from "./schools.api";
import { UI_MSG } from "../../config/uiMessages";

export function useSchools() {
  const [schools, setSchools] = useState([]);
  const [schoolsError, setSchoolsError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        setSchoolsError(null);
        const data = await fetchSchools();
        setSchools(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("Schools API failed:", e?.message || e);
        setSchools([]);
        setSchoolsError(UI_MSG.SCHOOLS_LOAD_FAILED);
      }
    })();
  }, []);

  const schoolsNear = useMemo(() => schools.slice(0, 10), [schools]);

  const openCatchment = useMemo(
    () => schools.filter((s) => s.has_catchment).slice(0, 10),
    [schools]
  );

  return { schools, schoolsNear, openCatchment, schoolsError };
}
